import { Autocomplete, Avatar, Icon, Thumbnail } from '@shopify/polaris';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import __ from 'languages/index';
import { SearchIcon } from '@shopify/polaris-icons';
import helpers from 'helpers/index';
import __helpers from 'helpers/index';
import { TypedPayment_profile, useGetPaymentProfile } from 'queries/payment_profile.query';
type TypedSearchVoucher = {
  current_payment_profile_id?: bigint | string /** vô dụng, không hoạt động ... */;
  onClose?: (val: TypedPayment_profile) => void;
  title: string;
  placeholder?: string;
  disabled?: boolean;
};

/**
 *
 * @param current_payment_profile_id bigint
 * @param  onClose callback with bigint userid
 * @returns
 */
export default function QuickSearchPaymentProfile({
  disabled,
  current_payment_profile_id = null,
  onClose,
  title,
  placeholder = 'Tìm Payment Profile'
}: TypedSearchVoucher) {
  /**!SECTION
   * Select người handler
   */

  const [mainQuery, setMainQuery] = useState({
    query: '',
    sort: 'createdAt:desc',
    is_cloned: 0,
    limit: 5
  });
  const {
    refetch: searchVoucher,
    isPending: userLoading,
    data
  } = useGetPaymentProfile(mainQuery);

  /**
   * User list
   */
  const [entities, setEntities] = useState<TypedPayment_profile[]>([]);
  /**
   */
  const [userSelected, setUserSelected] = useState<string[]>([]);
  const [userQuickSearchText, setUserQuickSearchText] = useState<string>('');
  const [userListForQuickOption, setUserListForQuickOption] = useState([]);
  useEffect(() => {
    if (data) {
      const {
        entities
      } = data;
      setEntities(entities); // bồi thêm data vào cái cũ
    }
  }, [data]);
  const onQueryToServer = useCallback(async () => {
    return await searchVoucher();
  }, []);
  useEffect(() => {
    let innerUser = [];
    if (entities) for (let paymentProfile of entities) {
      innerUser.push({
        value: paymentProfile.id,
        label: paymentProfile.payment_name
      });
      if (current_payment_profile_id && String(paymentProfile.id) === String(current_payment_profile_id)) {
        setUserQuickSearchText(paymentProfile.payment_name);
      }
    }
    setUserListForQuickOption(innerUser);
  }, [entities, current_payment_profile_id]);
  const onChangeMainQueryCallback = useMemo(() => {
    return helpers.debounce((_value: string) => {
      onQueryToServer?.call(this, _value);
    }, 400);
  }, []);
  const updateUserText = useCallback((value: string) => {
    setMainQuery(prevQuery => ({
      ...prevQuery,
      query: value
    }));
    setUserQuickSearchText(value);
    onChangeMainQueryCallback(value);
  }, []);
  const findUserSelectedInEntities = useCallback(paymentProfile_id => {
    if (Array.isArray(entities)) {
      let a = entities.filter(a => a.id === paymentProfile_id);
      return a[0] || null;
    }
  }, [entities]);
  const updateSelection = useCallback((selected: string[]) => {
    const selectedValue = selected.map(selectedItem => {
      const matchedOption = userListForQuickOption.find(option => {
        return option.value.match(selectedItem);
      });
      return matchedOption && matchedOption.label;
    });
    setUserSelected(selected);
    setUserQuickSearchText(selectedValue[0] || '');
    // @ts-ignore
    onClose?.call(this, findUserSelectedInEntities(selected[0]));
  }, [userListForQuickOption]);
  useEffect(() => {
    onChangeMainQueryCallback('');
  }, []);
  const textFieldSelectUser = <>
      <Autocomplete.TextField align="left" onChange={updateUserText} label={title} disabled={disabled} value={userQuickSearchText} prefix={<Icon source={SearchIcon} tone="base" />} placeholder={placeholder} autoComplete="off" />
    </>;
  return <>
      <Autocomplete options={userListForQuickOption} selected={userSelected} onSelect={updateSelection} textField={textFieldSelectUser} loading={userLoading} />
    </>;
}